import clsx from 'clsx';

export interface MenuListProps {
  title?: string;
  className?: string;
  children?: React.ReactNode;
}

export const MenuList = ({ children, title, className, ...props }: MenuListProps) => (
  <div className={clsx('flex gap-2', className)} {...props}>
    {title && <h6>{title}</h6>}
    {children}
  </div>
);
